// 9fbef606107a605d69c0edbcd8029e5d
import HEADER_CONSTANTS from './Header.constants';

export const openNavigationDrawer = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.OPEN_NAVIGATION_DRAWER,
  };
};

export const closeNavigationDrawer = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.CLOSE_NAVIGATION_DRAWER,
  };
};

export const setHideDrawerInfoSection = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.HIDE_DRAWER_INFO_SECTION,
  };
};

export const closeMiniBag = () => {
  return {
    type: HEADER_CONSTANTS.CLOSE_MINI_BAG,
  };
};

export const openMiniBag = () => {
  return {
    type: HEADER_CONSTANTS.OPEN_MINI_BAG,
  };
};

export const loadHeaderData = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.LOAD_HEADER_DATA,
  };
};

export const updateCartCount = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.CART_ITEM_COUNT,
  };
};

export const updateCartManually = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.UPDATE_CART_MANUALLY,
  };
};

export const removeL1PanelTimeOut = () => {
  return {
    type: HEADER_CONSTANTS.REMOVE_L1_PANEL_TIMEOUT,
  };
};

export const updateSBPEvent = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.UPDATE_SBP_EVENT,
  };
};

export const setCondensedStatus = (payload) => {
  return {
    payload,
    type: HEADER_CONSTANTS.SET_CONDENSED_STATUS,
  };
};

export const openAccountDrawer = () => {
  return {
    type: HEADER_CONSTANTS.OPEN_ACCOUNT_DRAWER,
  };
};

export const closeAccountDrawer = () => {
  return {
    type: HEADER_CONSTANTS.CLOSE_ACCOUNT_DRAWER,
  };
};

export default {
  loadHeaderData,
};
